// Pure, dependency-free predicates for the CJ order table's payment actions.
// Kept outside DropshippingOrders.js (same pattern as platformVisibility.js)
// so they can be unit-tested with plain node:test without pulling in React/
// react-router-dom/react-icons through the page component.
const canRetryPayment = (order) =>
  Boolean(order)
  && !order.paymentAttemptInProgress
  && order.paymentStatus === "failed"
  && order.failureCode !== "CJ_PAYMENT_NOT_SUPPORTED";

const canPayOnCJ = (order) =>
  Boolean(order) && order.paymentModeSnapshot === "manual" && Boolean(order.supplierOrderId) && order.paymentStatus === "manual_payment_required";

// Supplier order paid on CJ (set by the server when CJ's status moves past
// UNPAID). Paid -> "View Order"; not paid -> "Checkout" (where carrier review
// and "Pay on CJ" live). Never both as the primary action.
const isSupplierOrderPaid = (order) => Boolean(order) && order.paymentStatus === "paid";
const orderPrimaryAction = (order) => (isSupplierOrderPaid(order) ? "view" : "checkout");

module.exports = { canRetryPayment, canPayOnCJ, isSupplierOrderPaid, orderPrimaryAction };
